import { css } from "@emotion/css"
import React from "react"

import FooterAddress from "./FooterAddress/FooterAddress"
import FooterBottom from "./FooterBottom"
import FooterNav from "./FooterNav"

const Footer = () => {
  return (
    <footer className={style}>
      <FooterAddress />
      <FooterNav />
      <FooterBottom />
    </footer>
  )
}

export default Footer

const style = css`
  color: #fff;
  background: #1e9b24;
`
